// Generat automat din README.md
import React from 'react';
import { FileText, Upload, Search, Archive } from 'lucide-react';
import Card from '../../components/Card';

const ManagementDocumente = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Management Documente Contabile</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Arhivare digitală și organizare inteligentă a documentelor contabile
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Total Documente" icon={FileText}>
          <div className="text-2xl font-bold text-primary-600">1,245</div>
        </Card>
        <Card title="Adăugate Astăzi" icon={Upload}>
          <div className="text-2xl font-bold text-green-600">12</div>
        </Card>
        <Card title="Arhivate" icon={Archive}>
          <div className="text-2xl font-bold text-blue-600">890</div>
        </Card>
        <Card title="Pentru Revizie" icon={Search}>
          <div className="text-2xl font-bold text-yellow-600">8</div>
        </Card>
      </div>

      <Card title="Funcționalități Management Documente">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Upload și Procesare</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm">Recunoaștere automată OCR</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm">Clasificare inteligentă</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm">Extragere date automate</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm">Validare conformitate</span>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Organizare și Căutare</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <span className="text-sm">Căutare full-text avansată</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <span className="text-sm">Filtrare pe multiple criterii</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <span className="text-sm">Organizare pe dosare virtuale</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <span className="text-sm">Versioning și istoric</span>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ManagementDocumente;